import { SectionCheckbox } from 'services/api/vehicle-sections/types';
import styled from 'styled-components';

const Wrapper = styled.div<{ isNested: boolean }>`
  padding: 0 8px 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: ${props => (props.isNested ? '#EEF1F4' : 'inherit')};
`;

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const NotesWrapper = styled.div`
  border: 2px solid rgba(166, 215, 255, 1);
  border-radius: 20px;
  border-top-left-radius: 0;
  padding: 8px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  margin-top: 4px;
  text-align: center;
  width: fit-content;

  @media (max-width: 1024px) {
    font-size: 10px;
    line-height: 12px;
    padding: 6px;
  }
`;

const Label = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #666666;
`;

type Props = {
  checkboxes: SectionCheckbox[];
  isNested?: boolean;
};

export const CheckboxList = ({ checkboxes, isNested = false }: Props) => {
  return (
    <Wrapper isNested={isNested}>
      {checkboxes.map(checkbox => (
        <CheckboxWrapper>
          <Label>{checkbox.label}</Label>
          {checkbox.notes?.message && <NotesWrapper>{checkbox.notes.message}</NotesWrapper>}
        </CheckboxWrapper>
      ))}
    </Wrapper>
  );
};
